import React from 'react'
import { Grid, H2, Header } from '@cobalt/cobalt-react-components'
import { string, node, element } from 'prop-types'

const SettingItem = ({ title, actionButton, children }) => (
  <Grid noPadding>
    <Grid.Group>
      <Grid.Column all="60" medium="60" small="100" tiny="100">
        <React.Fragment>
          <Grid noPadding>
            {/* This group is necessary to do a padding */}
            <Grid.Group>
              <Grid.Column all="max">
                <Header borderless>
                  <Header.Heading>
                    <Header.Title>
                      <H2 asH5>{title}</H2>
                    </Header.Title>
                  </Header.Heading>
                  {actionButton && (
                    <Header.Actions>{actionButton}</Header.Actions>
                  )}
                </Header>
              </Grid.Column>
            </Grid.Group>
          </Grid>
        </React.Fragment>
        {children}
      </Grid.Column>
    </Grid.Group>
  </Grid>
)

SettingItem.propTypes = {
  test: string,
  title: string.isRequired,
  subtitle: string,
  actionButton: element,
  children: node
}

export default SettingItem
